import { Bot, RefreshCw, ArrowLeft, Menu, Plus } from 'lucide-react';

const ChatHeader = ({ agent, conversationTitle, onClearChat, onNewChat, onBack, onToggleDrawer, hasMessages }) => {
  const widgetSettings = agent?.widget_settings || {};
  
  const handleClearChat = () => {
    if (window.confirm('Tem certeza que deseja limpar esta conversa? Esta ação não pode ser desfeita.')) {
      onClearChat();
    }
  };
  
  return (
    <div className="bg-white p-4 lg:p-6 border-b-2 border-gray-100">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          
          {/* Back Button */}
          <button
            onClick={onBack}
            className="p-2 hover:bg-gray-100 rounded-xl transition-all"
          >
            <ArrowLeft className="w-6 h-6 text-gray-600" />
          </button>
          
          {/* Agent Info */}
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-2xl overflow-hidden bg-gradient-to-br from-indigo-100 to-green-100 p-0.5 flex-shrink-0">
              <div className="w-full h-full rounded-2xl overflow-hidden bg-white flex items-center justify-center">
                {widgetSettings?.logo_url ? (
                  <img 
                    src={widgetSettings.logo_url} 
                    alt={agent.name} 
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <Bot className="w-6 h-6 text-indigo-400" />
                )}
              </div>
            </div>
            
            <div>
              <h2 
                className="text-lg lg:text-xl font-bold text-gray-900" 
                style={{ fontFamily: widgetSettings.font_primary || 'Inter' }}
              >
                {agent.name}
              </h2>
              <p 
                className="text-sm text-gray-500" 
                style={{ fontFamily: widgetSettings.font_secondary || 'Roboto' }}
              >
                {conversationTitle || 'Nova conversa'}
              </p>
            </div>
          </div>
        </div>
        
        {/* Action Buttons */}
        <div className="flex items-center gap-2 lg:gap-3">
          {hasMessages && (
            <button 
              className="p-2 lg:px-4 lg:py-2 text-gray-600 hover:bg-gray-100 rounded-xl transition-all flex items-center gap-2"
              onClick={handleClearChat}
              title="Limpar conversa"
            >
              <RefreshCw className="w-5 h-5" />
              <span className="hidden lg:inline text-sm font-medium">Limpar</span>
            </button>
          )}
          
          <button 
            className="p-2 lg:px-4 lg:py-2 bg-gradient-to-r from-green-800 to-green-600 text-white hover:from-green-700 hover:to-green-700 rounded-xl transition-all flex items-center gap-2 shadow-md hover:shadow-lg transform hover:scale-[1.02] active:scale-[0.98]"
            onClick={onNewChat}
            title="Nova conversa"
          >
            <Plus className="w-5 h-5" />
            <span className="hidden lg:inline text-sm font-semibold">Nova Conversa</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;